const courseSettings = {
  language: "en",
  name: "Big Data Platforms, Autumn 2026",
  siteUrl: "https://big-data-platforms-26.mooc.fi/",
  githubUrl: "https://github.com/rage/big-data-platforms-26/",
  subtitle: "Introduction to Big Data Processing Frameworks",
  slug: "big-data-platforms-26",
  tmcCourse: "",
  quizzesId: "",
  tmcOrganization: "hy",
  organizationName: "University of Helsinki",
  bannerPath: "banner.jpg",
  courseId: "441952ac-a1ee-4d58-8c9d-2d18c182c8ae",
}

module.exports = courseSettings
